module.exports = __webpack_public_path__ + "static/img/mango.ac1d4cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/mango.jpg
// module id = DMDe
// module chunks = 1